var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegotiatedSupplyAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5F56DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4968 11.9971H24.0016C25.1066 11.9971 26.0025 12.8929 26.0025 13.9979V24.0021",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9988 16.0158H23.0013",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9988 20.0002H23.0013",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4981 28.0037H27.0029C28.1079 28.0037 29.0037 27.1079 29.0037 26.0029V25.0025C29.0037 24.45 28.5558 24.0021 28.0033 24.0021H17.9991C17.4466 24.0021 16.9987 24.45 16.9987 25.0025V26.5031C16.9987 27.3319 16.3269 28.0037 15.4981 28.0037V28.0037C14.6693 28.0037 13.9975 27.3319 13.9975 26.5031V13.4977C13.9975 12.6689 13.3256 11.9971 12.4968 11.9971V11.9971C11.6681 11.9971 10.9962 12.6689 10.9962 13.4977V15.9987C10.9962 16.5513 11.4441 16.9992 11.9966 16.9992H13.9975",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegotiatedSupplyAgreement);
export default __webpack_public_path__ + "static/media/NegotiatedSupplyAgreement.8d13311d960986673c5f2d6dd09e10af.svg";
export { ForwardRef as ReactComponent };